import ApiClient from './apiClient'
import { TosAndPrivacyPolicyResponse, TosAndPrivacyPolicyRequest } from '../types/tosAndPrivacyPolicy'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTosAndPrivacyPolicy = async (): Promise<any> => ApiClient.get(
  '/api/v1/renderer/tos_and_privacy_policy',
  (result: TosAndPrivacyPolicyResponse) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTosAndPrivacyPolicyAgreement = async (params: TosAndPrivacyPolicyRequest): Promise<any> => ApiClient.post(
  '/api/v1/renderer/tos_and_privacy_policy',
  () => {
    // do nothing
  },
  params,
)
